import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { LookupOption, LookupType } from '../../../models/LookupOption';
import { LookupService } from '../../../services/lookup.service';

@Component({
    selector: 'app-lookup-options-modal',
    templateUrl: './lookup-options-modal.component.html',
    styleUrls: ['./lookup-options-modal.component.css']
})
export class LookupOptionsModalComponent implements OnInit {
    public type: LookupType;
    public options: LookupOption[];
    public submitted = false;
    public submittedState = false;
    public isCollapsed: boolean[] = [];

    private _subscription = new Subscription();

    public constructor(
        public activeModal: NgbActiveModal,
        private _lookupService: LookupService,
    ) { }

    public ngOnInit(): void {
        this.refreshOptions();
    }

    public saveOption(f: UntypedFormGroup, option?: LookupOption): void {
        this.submitted = true;
        if (option) {
            this.submittedState = true;
        }

        if (f.invalid) {
            return;
        }

        this.submittedState = false;

        this.submitted = false;

        const newOption = {
            ...f.value,
            type: this.type
        };

        this._lookupService.saveOption(newOption, option?.id)
            .then(() => {
                this.refreshOptions();
            });
    }

    public deleteOption(lookupID: number): void {
        this._lookupService.deleteOption(lookupID)
            .then(() => {
                this.refreshOptions();
            });
    }

    /*public moveUp(state: KanbanState): void {
        this._recruitmentService.moveKanbanStateUp(state?.recruitment_state_ID as number)
            .then(() => {
                this.refreshStates();
            });
    }

    public moveDown(state: KanbanState): void {
        this._recruitmentService.moveKanbanStateDown(state?.recruitment_state_ID as number)
            .then(() => {
                this.refreshStates();
            });
    }*/

    public refreshOptions(): void {
        /*this._subscription.add(this._lookupService.getOptionsListByType(this.type)
            .subscribe((options) => {
                this.options = options.data.find(responseRow => responseRow.type === this.type).lookups;
            }));*/

        this._subscription.add(this._lookupService.getActiveOptionsByType(this.type, false)
            .subscribe(options => {
                this.options = options;
            }));
    }
}
